export default __webpack_public_path__ + "static/media/headerImg.e656f630.png";